
import { connect } from 'react-redux';

import Navigate from "./navigate";
import { navigatePath } from "./actions";

const mapStateToProps = (state) => {
  return {
    ...state.path,
  };
};

const mapDispatchToProps = (dispatch) => {
  return({
    navigatePath: (path, cb) => {dispatch(navigatePath(path, cb))},
  })
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigate);
